export const blobRegex = new RegExp("^blob:", "i");
export const httpOrHttpsRegex = new RegExp("^(http|https)://", "i");
